import { Account } from 'shared/types/account';
import { BusinessUnit } from 'shared/types/businessUnit';
import { LineItem, NgcCart } from 'shared/types/ngcCart';
import { Product } from 'shared/types/product';
import { Country } from './utils/countryHelper';
import { YOGA_MAT_CONSTANTS } from '../../lululemon-b2b-utils/constants';

export const isYogaMatItemType = (itemType?: string): boolean => {
  if (!itemType) return false;
  return itemType.toLowerCase().includes(YOGA_MAT_CONSTANTS.ITEM_TYPE);
};

/**
 * Determines whether the logged-in user is a Canadian user.
 * User is Canadian only if BOTH partner country AND business unit address country are CA.
 */
export const isCanadianUser = (account?: Account, businessUnit?: BusinessUnit): boolean => {
  const partnerCountry = account?.companyProfile?.partnerCountry;
  const businessUnitAddressCountry = businessUnit?.addresses?.[0]?.country;

  const isPartnerCountryCA = partnerCountry?.toUpperCase() === Country.CA.toUpperCase();
  const isBusinessUnitAddressCountryCA = businessUnitAddressCountry?.toUpperCase() === Country.CA.toUpperCase();

  const result = isPartnerCountryCA && isBusinessUnitAddressCountryCA;

  return result;
};

/**
 * Checks if a line item is a yoga mat based on its itemType.
 */
export const isYogaMatLineItem = (item: LineItem): boolean => {
  return isYogaMatItemType(item?.itemType);
};

/**
 * Checks if the cart contains at least one yoga mat item.
 */
export const cartHasYogaMats = (cart?: NgcCart): boolean => {
  if (!cart?.lineItems || cart.lineItems.length === 0) return false;

  const result = cart.lineItems.some((item: LineItem) => isYogaMatLineItem(item));
  return result;
};

/**
 * Checks whether the cart contains non-Yoga mat items.
 */
export const cartHasNonYogaMats = (cart?: NgcCart): boolean => {
  if (!cart?.lineItems || cart.lineItems.length === 0) return false;

  const result = cart.lineItems.some((item: LineItem) => !isYogaMatLineItem(item));
  return result;
};

/**
 * Determines whether a product is a Yoga mat based on its variants' itemType.
 */
export const isYogaMatProduct = (product?: Product): boolean => {
  if (!product?.variants || product.variants.length === 0) return false;

  return product.variants.some((variant) => isYogaMatItemType(variant.itemType));
};
